/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';

import {AngularModalService} from '../common/modal/angular-modal.service';
import {CreativeAttachModalComponent} from './creative-attach-modal.component';

@Injectable({providedIn: 'root'})
export class CreativeAttachModalService {
  constructor(private readonly angularModalService: AngularModalService) {
  }

  open(list: any, Creative: any, onComplete?: (updatedCreatives?: any, bulkSelection?: any) => void): void {
    this.angularModalService.show(CreativeAttachModalComponent, {
      initialState: {
        list,
        Creative,
        onComplete
      }
    });
  }
}
